import { VITE_USE_LOCAL_BACKEND_API } from "@/modules/global-state/globalEnv";

export const clientEnvLocalBackendApiIsEnabled = (): boolean => {
  return VITE_USE_LOCAL_BACKEND_API;
};
